/**
 * Shared pagination constants for tables and data lists
 * Used across both frontend and backend for consistent pagination behavior
 */

/**
 * Default page size for data tables and lists
 */
export const DEFAULT_PAGE_SIZE = 20;

/**
 * Available page size options for pagination controls
 */
export const PAGE_SIZE_OPTIONS = ["10", "20", "50", "100"];

/**
 * Maximum page size limit to prevent performance issues
 */
export const MAX_PAGE_SIZE = 100;

/**
 * Minimum page size
 */
export const MIN_PAGE_SIZE = 10;

/**
 * Default sort order
 */
export const DEFAULT_SORT = "desc" as const;

/**
 * Default sort key for most data tables
 */
export const DEFAULT_SORT_KEY = "updatedAt";

/**
 * Pagination position constants for Ant Design tables
 */
export const TABLE_PAGINATION_POSITION = ["bottomCenter"];

/**
 * Default table size for Ant Design tables
 */
export const DEFAULT_TABLE_SIZE = "default" as const;

/**
 * Type definitions for pagination constants
 */
export type PageSizeOption = "10" | "20" | "50" | "100";
export type SortOrder = typeof DEFAULT_SORT | "asc";
export type TableSize =
	| typeof DEFAULT_TABLE_SIZE
	| "small"
	| "middle"
	| "large";
